import { render, staticRenderFns } from "./GraficoVendedorQuantidade.vue?vue&type=template&id=7ffc90aa&"
import script from "./GraficoVendedorQuantidade.vue?vue&type=script&lang=ts&"
export * from "./GraficoVendedorQuantidade.vue?vue&type=script&lang=ts&"
import style0 from "./GraficoVendedorQuantidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports